/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { Group, GroupProps } from '@mantine/core'

export type ToolbarProps = GroupProps

function Toolbar (props: ToolbarProps) {
  const { children, ...others } = props
  return (
    <Group gap="xs" {...others}>
      {children}
    </Group>
  )
}

export default Toolbar
